import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { THEME } from '@pkg/config/misc/theme';
import { surpriseBagSeoKeyword } from '@pkg/config/sanity/slugs';

/**
 * Surprise-bag routes force APP theme (legacy web behaviour).
 * Host apps without those routes just use the CMS theme.
 */
export function resolveSectionTheme(
  theme: THEME | undefined,
  slugParam: string | string[] | undefined,
): THEME | undefined {
  if (Array.isArray(slugParam) && slugParam.includes(surpriseBagSeoKeyword)) {
    return THEME.APP;
  }
  return theme;
}

export function useResolvedSectionTheme(theme: MaybeRefOrGetter<THEME | undefined>) {
  return computed(() => {
    try {
      return resolveSectionTheme(toValue(theme), useRoute().params.slug);
    } catch {
      // Outside Nuxt route context
      return toValue(theme);
    }
  });
}
